<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <conversation-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></conversation-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';
  import ConversationForm from '../../components/conversations/form';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ConversationForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Conversation'
        }

        return 'Create Conversation'
      },
    },
    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-conversations-table');
      },
    },

    created() {
      eventBus.$on('show-add-conversation-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-conversation-dialog', this.show);
    }
  }
</script>
